<template>
  <div class="navi-wrap px-4 py-4">
    <v-card
    elevation="0"
  >
    <div class="card-main text-center">
      <h3 class="text mb-2">{{title}}</h3>
      <p class="subtitle-2">{{desc}}</p>
      <img :src="img" alt="" srcset="">
    </div>
  </v-card>
  </div>
</template>
<script>
export default {
  name: 'NaviGuide',
  props: {
    img: {
      type: String,
      // eslint-disable-next-line global-require
      default: () => require('../assets/person-insights.svg'),
    },
    title: {
      type: String,
      default: '超级搜索',
    },
    desc: {
      type: String,
      default: '搜帖子、搜红人、搜品牌、社交舆情分析..',
    },
  },
};
</script>
<style lang="scss" scoped>
.navi-wrap {
  max-width: 100%;
  cursor: pointer;
  border-radius: 8px;
  border: 1px solid #C5C4D5;
  &:hover {
    box-shadow: 0px 2px 4px 3px rgba(15, 3, 66, 0.14);
  }
  .card-main {
    color: #252262;
    p {
      height: 4.125rem;
    }
  }
}
</style>
